module.exports = __webpack_public_path__ + "static/media/1018335.03d6de0a.png";